<template>
  <div class="login">
    <div style="height: 70px"></div>
    <div class="content">
      <div class="cont_body">
        <div class="header">
          <img src="../assets/logo_dark.png" />
          <h1>
            {{ title }}
            <span>数据可视化</span>
          </h1>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="factoryCode">
            <el-input v-model="ruleForm.factoryCode" @blur="checkFactoryCode" autocomplete="off"
              placeholder="请输入工厂代码"></el-input>
          </el-form-item>
          <el-form-item prop="username">
            <el-input v-model="ruleForm.username" autocomplete="off" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="text-align:right">
      <el-button type="primary">
        <a style="color:white;text-decoration:none" href="http://kanban.biqs.cn/assets/BIQS_Kanban.apk">
          <h1>安装到电视</h1>
        </a>
      </el-button>
    </div>
  </div>
</template>

<script>
import service from "@/utils/api";
export default {
  name: "login",
  data() {
    var checkFactoryCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("工厂代码不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        callback();
      }
    };
    var checkUser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("用户不能为空"));
      } else {
        callback();
      }
    };
    return {
      title: "BIQS",
      factoryList: [],  // 工厂列表
      factoryLoading: false,  // 工厂列表加载状态
      ruleForm: {
        factoryCode: "",  // 工厂代码
        http: "",  // 服务器地址（从工厂列表匹配）
        username: "",
        password: "",
      },
      rules: {
        factoryCode: [{ validator: checkFactoryCode, trigger: "blur" }],
        username: [{ validator: checkUser, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 预加载工厂列表
    async loadFactoryList() {
      try {
        this.factoryLoading = true;
        // 从本地静态文件加载加密的工厂列表
        const response = await fetch("./static/host/bc65a89d14fd6c791eecf1f0be3f380d.txt");
        const base64Text = await response.text();
        // base64 解码
        const decodedText = atob(base64Text);
        this.factoryList = JSON.parse(decodedText);
      } catch (error) {
        console.error("加载工厂列表失败:", error);
        this.$message.error("加载工厂列表失败，请检查文件");
      } finally {
        this.factoryLoading = false;
      }
    },
    // 验证工厂代码
    checkFactoryCode() {
      const code = this.ruleForm.factoryCode.trim();
      if (!code) return;

      const factory = this.factoryList.find(f => f.name.toLowerCase() === code.toLowerCase());
      if (factory) {
        this.ruleForm.http = factory.url;
      } else {
        this.ruleForm.http = "";
        this.$message.warning("不存在工厂代码: " + code);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证工厂代码是否存在
          const code = this.ruleForm.factoryCode.trim();
          const factory = this.factoryList.find(f => f.name.toLowerCase() === code.toLowerCase());
          if (!factory) {
            this.$message.error("不存在工厂代码: " + code);
            return;
          }
          // 设置服务器地址
         // this.ruleForm.http = 'http://localhost:8088/';
          this.ruleForm.http = factory.url;
          var useRsa = factory['useRsaEncrypt'];
          sessionStorage.removeItem("token");
          service
            .login(this.ruleForm, useRsa)
            .then((res) => {
              if (res.success === true) {
                var bean = res.value;
                var tenant = "";
                if (bean["tenant"]) {
                  tenant = bean["tenant"]["name"];
                }

                var user = {
                  token: bean.token,
                  http: this.ruleForm.http,
                  factoryCode: this.ruleForm.factoryCode,
                  tenant: tenant,
                };

                localStorage.setItem('http', this.ruleForm.http);
                localStorage.setItem('factoryCode', this.ruleForm.factoryCode);
                localStorage.setItem("user_session", JSON.stringify(user));

                if (res["tenants"] && res["tenants"].length > 0) {
                  this.$router.push({ path: "/tenants", replace: true });
                } else {
                  this.$router.push({ path: "/home", replace: true });
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              this.$message.error("网络错误，请确认服务器");
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  async mounted() {
    // 预加载工厂列表
   await this.loadFactoryList();

    // 初始化工厂代码
    const factoryCode = this.$route.query.factoryCode || localStorage.getItem('factoryCode');
    if (factoryCode) {
      this.ruleForm.factoryCode = factoryCode;
      this.$nextTick(() => {
        this.checkFactoryCode();
      });
    }

    // 初始化用户名
    var username = this.$route.query.username;
    if (username) {
      this.ruleForm.username = username;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./login.css'></style>



// WEBPACK FOOTER //
// src/login/login.vue